import React from 'react'
import { Subscription } from 'react-apollo'
import { camelCase } from 'camel-case'
import { getIbStatus } from './queries/get-ib-status'
import { DooerComGetIbStatus, DooerComGetIbStatusVariables } from './queries/__generated__/DooerComGetIbStatus'

interface IIbSession {
  id: string
  status: string | null
  message: string | null
  institution: string | null
  bankIdQRImage?: string | null
  autoStartToken?: string | null
}

interface IIbSessionStatusProps {
  sessionId: string
  children: (props: { session: IIbSession }) => React.ReactNode
  onDone: () => void
}

interface IIbSessionStatusState {
  session: IIbSession
}

export default class IbSessionStatus extends React.Component<IIbSessionStatusProps, IIbSessionStatusState> {
  state = {
    session: {
      id: this.props.sessionId,
      status: 'pending',
      message: '',
      institution: '',
    },
  }

  render() {
    return (
      <React.Fragment>
        {this.props.children(this.state)}
        <Subscription<DooerComGetIbStatus, DooerComGetIbStatusVariables>
          onSubscriptionData={({ subscriptionData }) => {
            const status = subscriptionData && subscriptionData.data && subscriptionData.data.ibSessionStatusV2

            if (status && status.__typename === 'IbSessionMessage') {
              this.setState({
                session: {
                  ...this.state.session,
                  message: status.message,
                  institution: status.institution,
                },
              })
            }

            if (status && status.__typename === 'IbSessionStatusUpdate' && status.status) {
              this.setState({
                session: {
                  ...this.state.session,
                  status: camelCase(status.status),
                  institution: status.institution,
                  bankIdQRImage: status.bankIdQRImage,
                  autoStartToken: status.autoStartToken,
                },
              })

              if (status && status.status === 'done' && this.props.onDone) {
                this.props.onDone()
              }
            }
          }}
          subscription={getIbStatus}
          variables={{ sessionId: this.props.sessionId }}
        />
      </React.Fragment>
    )
  }
}
